export default __webpack_public_path__ + "d578f91.png";